import { CALENDAR_KEYS } from '@/types/admin/events';
import { ADMIN_COLORS } from '@/constants/admin';

export const getEventStatusColor = (status: string): string => {
  const key = CALENDAR_KEYS.find((k) => k.title === status);
  return key?.color || ADMIN_COLORS.TEXT_SECONDARY;
};


